<div class="flex-container overflow-hidden">
  <div
    class="standart-table-wrapper"
    infiniteScroll
    (scrolled)="doScroll()"
    [scrollWindow]="false"
  >
    <ng-container *ngIf="groupsDTO; else loading">
      <table class="standart-table">
        <thead
          class="standart-table-header"
          sortable
          [directions]="sortDirections"
          (sort)="callOnSort($event)"
        >
          <th class="expand-cell"></th>
          <th sortBy="name">Provider Groups</th>
          <th sortBy="groupId">Group ID</th>
          <th style="width: 172px">
            <ng-container *ngIf="!isViewOnly && !isClientAdmin">
              <a
                href="javascript:void(0);"
                *ngIf="!!!headers?.disableAdd"
                class="add-group-btn"
                (click)="doEdit(undefined)"
              >
                <i class="fas fa-plus fz-16 mr-2"></i>
                <div class="text-nowrap">Add Provider Group</div>
              </a>
            </ng-container>
          </th>
        </thead>

        <tbody>
          <ng-container *ngIf="groupsDTO?.length; else emptyRow">
            <ng-container *ngFor="let pgroup of groupsDTO">
              <tr [class.row-inactive]="!pgroup.isActive">
                <td class="expand-cell">
                  <a
                    href="javascript:void(0);"
                    (click)="pgroup.isExpanded = !pgroup.isExpanded"
                    [class.expanded]="pgroup.isExpanded"
                    *ngIf="pgroup.providers && pgroup.providers.length > 0"
                    class="standart-link-action"
                  >
                    <i class="fas fa-chevron-down"></i>
                  </a>
                </td>

                <td>
                  {{ pgroup.name }}
                </td>
                <td>
                  {{ pgroup.groupId }}
                </td>
                <td class="actions-cell">
                  <div class="d-flex">
                    <div ngbDropdown container="body" class="ml-auto">
                      <a
                        href="javascript:void(0);"
                        class="standart-link-action ml-auto"
                        ngbDropdownToggle
                      >
                        <i class="fas fa-chevron-circle-down"></i>
                      </a>
                      <div class="padding-top" ngbDropdownMenu>
                        <div class="dropdown-menu-inside">
                          <button ngbDropdownItem (click)="doEdit(pgroup)">
                            {{ actionText }}
                          </button>
                          <ng-container *ngIf="!isViewOnly">
                            <button
                              ngbDropdownItem
                              (click)="doDelete(pgroup)"
                              *ngIf="pgroup.isActive"
                            >
                              Deactivate Group
                            </button>
                            <button
                              ngbDropdownItem
                              (click)="doProviderCreate(pgroup, undefined)"
                              class="with-border dropdown-item"
                            >
                              Add Provider
                            </button>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                class="standart-table-row-inner"
                [ngbCollapse]="pgroup.isExpanded ?? false"
              >
                <td colspan="4">
                  <div class="content p-0">
                    <div class="inner-table mh-unset">
                      <providers-grid
                        [providers]="pgroup.providers"
                        [sortDirections]="{ lastName: 'ASC' }"
                        [moreRowsExists]="false"
                        (create)="doProviderCreate(pgroup, $event)"
                        (editComplete)="providerEditComplete(pgroup)"
                        (sort)="onProvidersSort($event, pgroup)"
                      >
                      </providers-grid>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="moreRowsExists">
            <tr>
              <td colspan="8">
                <loader></loader>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <loader style="min-height: 100px"></loader>
</ng-template>

<ng-template #emptyRow>
  <tr>
    <td colspan="8" class="pt-3 pb-3">
      <empty-state size="sm" title="No results found"></empty-state>
    </td>
  </tr>
</ng-template>
